import { AUTOCOMPLETE_CLEAR, AUTOCOMPLETE_SET_EMPTY, AUTOCOMPLETE_UNREGISTER, AUTOCOMPLETE_UPDATE } from 'constants/reduxActions';

// Updates error message to notify about the failed fetches.
export default function autoComplete(state = {}, action) {
  const { type, id, text, data } = action;
  const newState = { ...state };
  switch (type) {
    case AUTOCOMPLETE_CLEAR:
      return { ...state, [id]: { values: null, isEmpty: false } };
    case AUTOCOMPLETE_UNREGISTER:
      delete newState[id];
      return newState;
    case AUTOCOMPLETE_UPDATE:
      return { ...state, [id]: { text, values: data, isEmpty: state[id].isEmpty || false } };
    case AUTOCOMPLETE_SET_EMPTY:
      return { ...newState, [id]: { values: [], text: null, isEmpty: true } };
    default:
      return state;
  }
}
